import { baseApi } from "../../../../app/api";

const CUSTOM_REST_API_BASE =
  window.commonVariables?.customRestApiBase || "/wp-json/ecommerce-app/v1";

export const appointmentApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getFullyBookedDates: builder.query<
      string[],
      { year: number; month: number }
    >({
      query: ({ year, month }) => ({
        url: `${CUSTOM_REST_API_BASE}/appointments/fully-booked-dates`,
        params: { year, month },
      }),
      transformResponse: (response: { fully_booked_dates: string[] }) =>
        response.fully_booked_dates,
    }),
    getAvailableTimes: builder.query<string[], string>({
      query: (date) => ({
        url: `${CUSTOM_REST_API_BASE}/appointments/available-times`,
        params: { date },
      }),
      transformResponse: (response: { available_times: string[] }) =>
        response.available_times,
    }),
  }),
});

export const { useGetFullyBookedDatesQuery, useLazyGetAvailableTimesQuery } =
  appointmentApi;
